"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const userInfoState_1 = __importDefault(require("../userInfoState"));
const react_i18next_1 = require("react-i18next");
const svgs_1 = require("@@/assets/svgs");
const MenuItem_1 = __importDefault(require("@mui/material/MenuItem"));
function default_1() {
    const { has_new } = (0, recoil_1.useRecoilValue)(userInfoState_1.default);
    const historyMenuItemSx = {
        flex: 1,
        flexDirection: 'column',
        justifyContent: 'center',
        rowGap: '4px',
        padding: '9px',
        fontSize: '13px',
    };
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsxs)("div", Object.assign({ css: { display: 'flex' } }, { children: [(0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ component: "a", href: "/room/feed-new", sx: historyMenuItemSx }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.FondeeIconSvg, {}), t('N-구독')] })), (0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ component: "a", href: "/order/history", sx: historyMenuItemSx }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.OrderHistorySvg, {}), t('구매내역')] })), (0, jsx_runtime_1.jsxs)(MenuItem_1.default, Object.assign({ component: "a", href: "/room/history", sx: historyMenuItemSx }, { children: [(0, jsx_runtime_1.jsx)(svgs_1.SalesHistorySvg, {}), t('판매내역'), has_new && (0, jsx_runtime_1.jsx)(svgs_1.NewIconSvg, { css: { position: 'absolute', top: '3px', right: '45px' } })] }))] })));
}
exports.default = default_1;
